export default "__VITE_ASSET__CMsMGZS4__"